import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import { StoreProps } from 'src/stores'
import TextInput from '../../../atoms/input/TextInput'

interface State {
  valid: boolean
  noRedirect: boolean
}

const nudges = new Map([
  ['INFO', 'Es fühlt sich gut an, vorgesorgt zu haben.'],
  ['PLAN', 'Es fühlt sich gut an, vorgesorgt zu haben.'],
  [
    'COMPARE',
    'Wir helfen Ihnen gerne dabei, das beste Vorsorgeangebot für Sie zu finden.'
  ]
])

@inject('wizardStore')
@observer
export class ProvisionBirthYearInput extends React.Component<
  StoreProps,
  State
> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.provision.birthYear,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionBirthYear' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionBirthYear' })
  }

  decideNudge = () => {
    const { wizardStore } = this.props
    return nudges.get(wizardStore.provision.provisionReason)
  }

  validateYear = (birthYear) => {
    const now = new Date()
    return (
      birthYear != null &&
      birthYear.length == 4 &&
      /^\d+$/.test(birthYear) &&
      +birthYear > 1900 &&
      +birthYear < now.getFullYear() - 17
    )
  }

  handleChange = (e) => {
    const { wizardStore } = this.props
    wizardStore.provision.birthYear = e
    if (this.validateYear(wizardStore.provision.birthYear)) {
      this.setState({ valid: true })
    } else {
      this.setState({ valid: false })
    }
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={45} end={55}>
              <p>
                <i className='fas fa-check'></i>
                {this.decideNudge()}
              </p>
            </ProgressBar>
          </ProgressBarContainerWizard>
          <Question>Was ist Ihr Geburtsjahr?</Question>
          <FormContainer>
            <TextInput
              value={wizardStore.provision.birthYear}
              name='birthYear'
              centered
              placeholder='JJJJ'
              onChange={this.handleChange}
              validate={this.validateYear}
            />
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(ProvisionBirthYearInput)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/provision/ProvisionBirthYearInput.tsx